import React from "react";
import { ScaleIcon } from "lucide-react";
import { BailCalculator } from "../BailCalculator";
import { SectionHeading } from "../ui/SectionHeading";
export function CalculatorSection() {
  return <section aria-labelledby="calc-title" className="section-y gutter bg-white" data-id="element-174" data-mp="2ubt4ou79sgyv">
      <div className="grid items-center gap-[clamp(3rem,6vw,8rem)] lg:grid-cols-2 ultra:grid-cols-[0.9fr_1.1fr]" data-id="element-175" data-mp="2ycd0nug3xejf">
        <div data-id="element-176" data-mp="2kcajybjjcr5r">
          <SectionHeading id="calc-title" eyebrow="Bail bond calculator" title={<>
                Know the cost <em className="text-gold-hover" data-id="element-178" data-mp="2p9kbpxuedewr">before you call.</em>
              </>} intro="Bail bond pricing in Nevada is set by law, so every honest bondsman charges the same premium. Here's how it adds up." data-id="element-177" data-mp="2kbsgatujnant" />
          <dl className="mt-10 grid gap-6 sm:grid-cols-2" data-id="element-179" data-mp="9lu1ey166w2l">
            <div className="border-t border-gold/40 pt-5" data-id="element-180" data-mp="dmdthn6vz9hv">
              <dt className="font-serif text-4xl text-navy" data-id="element-181" data-mp="dlueofcj9182">15%</dt>
              <dd className="mt-2 text-muted" data-id="element-182" data-mp="3m46mxibgy4cm">of the bail amount, or $50 — whichever is greater. This is the bond premium, set by NRS 697.300.</dd>
            </div>
            <div className="border-t border-gold/40 pt-5" data-id="element-183" data-mp="3vurv9xgy2n8q">
              <dt className="font-serif text-4xl text-navy" data-id="element-184" data-mp="3vu8dcgranyup">$50</dt>
              <dd className="mt-2 text-muted" data-id="element-185" data-mp="3qvex4gkmhtqu">jail filing fee for each case number. Every jail charges it to process a bond.</dd>
            </div>
          </dl>
          <p className="mt-8 flex items-start gap-3 text-sm text-muted" data-id="element-186" data-mp="337xcr63otxxw">
            <ScaleIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-hover" strokeWidth={1.5} aria-hidden="true" data-id="element-187" data-mp="2y8kgjuqxfein" />
            The premium is the fee you pay us to post the full bail amount on your loved one's behalf.
          </p>
        </div>
        <div className="relative" data-id="element-188" data-mp="sdsvmf10sq95">
          <div className="gold-glow pointer-events-none absolute -inset-12" aria-hidden="true" data-id="element-189" data-mp="scztxsgx4qxv" />
          <div className="relative" data-id="element-190" data-mp="ndwssj4274v6">
            <BailCalculator inputId="home-bail-amount" data-id="element-191" data-mp="nh2f5qlazsn7" />
          </div>
        </div>
      </div>
    </section>;
}